import { FormlyFieldConfig } from 'ng-formly';
export const metadataFields: Array<FormlyFieldConfig> = [
    {
        key: 'name',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: 'Unique name for the metadata',
            required: true,
            label: 'Entity Name'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'plural_label',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Plural Label'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'deployment_status',
        type: 'select-component',
        templateOptions: {
            default: 'dev',
            options: [
                {
                    label: 'Sandbox',
                    value: 'sandbox'
                },
                {
                    label: 'Production',
                    value: 'Production'
                }
            ],
            label: 'Status',
            required: true,
            placeholder: 'Select Status'
        }
    }
]


// WEBPACK FOOTER //
// ./src/app/shared/formfields/metadata.ts